import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { H5PPlayerUI } from '@lumieducation/h5p-react';
import { Container, Alert, Button } from 'react-bootstrap';
import { ContentService } from '../services/ContentService';

interface PlayPageProps {
    contentService: ContentService;
}

const PlayPage: React.FC<PlayPageProps> = ({ contentService }) => {
    const { contentId } = useParams<{ contentId: string }>();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [playerModel, setPlayerModel] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const h5pPlayer = useRef<H5PPlayerUI>(null);

    const contextId = searchParams.get('contextId') || undefined;
    const asUserId = searchParams.get('asUserId') || undefined;
    const readOnlyState = searchParams.get('readOnlyState') === 'true';

    useEffect(() => {
        const loadContent = async () => {
            if (!contentId) {
                setError('Content ID is required');
                setLoading(false);
                return;
            }

            try {
                setLoading(true);
                setError(null);
                const model = await contentService.getPlay(
                    contentId,
                    contextId,
                    asUserId,
                    readOnlyState
                );
                setPlayerModel(model);
            } catch (err: any) {
                console.error('Error loading H5P content:', err);
                setError(err.message || 'Failed to load H5P content');
            } finally {
                setLoading(false);
            }
        };

        loadContent();
    }, [contentId, contextId, asUserId, readOnlyState, contentService]);

    const handlePlayerInitialized = () => {
        console.log('H5P Player initialized');
    };

    const handlexAPIStatement = (statement: any, context: any, event: any) => {
        console.log('xAPI Statement:', statement);
    };

    if (loading) {
        return (
            <Container className="mt-5">
                <Alert variant="info">Loading H5P content...</Alert>
            </Container>
        );
    }

    if (error) {
        return (
            <Container className="mt-5">
                <Alert variant="danger">
                    <Alert.Heading>Error</Alert.Heading>
                    <p>{error}</p>
                    <hr />
                    <div className="d-flex justify-content-end">
                        <Button onClick={() => navigate('/')} variant="outline-danger">
                            Back to Home
                        </Button>
                    </div>
                </Alert>
            </Container>
        );
    }

    if (!playerModel) {
        return (
            <Container className="mt-5">
                <Alert variant="warning">No content available</Alert>
            </Container>
        );
    }

    return (
        <Container className="mt-4">
            <div className="mb-3">
            </div>
            <div>
                <H5PPlayerUI
                    ref={h5pPlayer}
                    contentId={playerModel.contentId}
                    contextId={contextId}
                    asUserId={asUserId}
                    readOnlyState={readOnlyState}
                    loadContentCallback={async () => playerModel}
                    onInitialized={handlePlayerInitialized}
                    onxAPIStatement={handlexAPIStatement}
                />
            </div>
        </Container>
    );
};

export default PlayPage;

